export const untitledDocument = {
  fileName: "untitled-document",
  lastSaveDate: new Date(),
  content: ``
};
